/**
 * Header Component
 */

import React from 'react';
import { useTheme } from 'styled-components';
import { HeaderProps } from '../animatedModal.types';
import { Wrapper, Title, ButtonsWrapper, CloseButtonWrapper } from './header.style';
import Button from '../../Button/button';
import { ButtonStyles, ButtonShapes } from '../../Button/button.types';

const Header = ({
  title,
  button,
  handlers,
  disableClose,
  ariaLabel = 'close',
  closeButtonRef,
  closeButtonRight = false,
}: HeaderProps) => {
  const theme = useTheme();
  return (
    <Wrapper>
      <ButtonsWrapper closeButtonRight={closeButtonRight}>
        <CloseButtonWrapper>
          <Button
            iconName="close"
            handlers={handlers}
            styleName={ButtonStyles.DEFAULT}
            shape={ButtonShapes.HOLLOW_BORDERLESS}
            disabled={disableClose}
            ariaLabel={ariaLabel}
            ref={closeButtonRef}
          />
        </CloseButtonWrapper>
        {button && button}
      </ButtonsWrapper>
      {title && <Title theme={theme}>{title}</Title>}
    </Wrapper>
  );
};

export default Header;
